document.addEventListener('DOMContentLoaded', () => {

  const sections = document.querySelectorAll('.featured-tabs-section');

  sections.forEach(section => {

    const buttons = section.querySelectorAll('.featured-tab-btn');
    const panels = section.querySelectorAll('.featured-tab-panel');

    buttons.forEach(button => {

      button.addEventListener('click', () => {

        const target = button.dataset.tab;

        // Remove active state
        buttons.forEach(btn => btn.classList.remove('active'));
        panels.forEach(panel => panel.classList.remove('active'));

        // Add active state
        button.classList.add('active');

        const panel = section.querySelector(`#tab-${target}`);

        if (panel) {
          panel.classList.add('active');
        }

      });

    });

  });

});